import React from 'react';

import Tooltip from '@material-ui/core/Tooltip';

import { UiDropdownOptionWithTooltip } from '../../ui/ui-dropdown-option-with-tooltip';

import { ACTIVE_STATUSES, JOB_STATUS_TEXT } from '../../util/job-status';
import {
  FilledSmallCircleIcon,
  ICON_NAMES,
  MaterialDesignIcon,
} from '../../util/material-design-icons';

const Icon = ({ jobStatus }: { jobStatus?: JobStatus }) => {
  if (jobStatus === undefined) {
    return null;
  }
  const isActiveJob = ACTIVE_STATUSES.includes(jobStatus);
  const status = JOB_STATUS_TEXT[jobStatus];

  return isActiveJob ? (
    <div className="u-color-green typo-body u-margin-top-xs u-margin-right">
      <Tooltip title={status} arrow enterDelay={700} enterNextDelay={700}>
        <span>
          <FilledSmallCircleIcon size="xs" className="u-color-green" />
        </span>
      </Tooltip>
    </div>
  ) : (
    <div className="u-color-gray typo-medium typo-body u-margin-top-xs u-margin-right">
      <Tooltip title={status} arrow enterDelay={700} enterNextDelay={700}>
        <span>
          <MaterialDesignIcon iconName={ICON_NAMES.FIBER_MANUAL_RECORD} size="xs" color="gray" />
        </span>
      </Tooltip>
    </div>
  );
};

export const JobDropdownOption = ({
  label,
  isSelected,
  jobStatus,
}: {
  label: string;
  isSelected: boolean;
  jobStatus?: JobStatus;
}) => (
  <UiDropdownOptionWithTooltip
    tooltipText={label}
    option={label}
    isSelected={isSelected}
    className={isSelected ? 'u-padding-left-md u-padding-right-xl' : 'u-padding-x-xl'}
    isSelectable
    Icon={<Icon jobStatus={jobStatus} />}
  />
);
